import { render } from "./BookingDetailsForm.vue?vue&type=template&id=53ff6bd8"
import script from "./BookingDetailsForm.vue?vue&type=script&lang=js"
export * from "./BookingDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__